"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerGroupUrl = exports.expandCustomerGroup = exports.expandDiscountCode = exports.expandProductType = exports.orderUrl = exports.paymentFormProfileUrl = exports.paymentFormUrl = exports.paymentFormSecret = exports.shippingMethodsUrl = exports.cartUrl = exports.productUrl = void 0;
const uuid_1 = require("uuid");
const locale_1 = require("../commercetools/locale");
const config_1 = require("../config");
/** @deprecated **/
const { domain } = locale_1.LOCALE_INFO;
exports.productUrl = `${config_1.baseApiUrl}/products/v1`;
exports.cartUrl = `${config_1.baseApiUrl}/carts/v1/carts`;
exports.shippingMethodsUrl = `${config_1.baseApiUrl}/carts/v2/shipping-methods`;
/** @deprecated **/
exports.paymentFormSecret = (0, uuid_1.v4)();
/** @deprecated **/
exports.paymentFormUrl = `${config_1.baseApiUrl}/payments/v1/payment/formToken`;
/** @deprecated **/
exports.paymentFormProfileUrl = `${config_1.baseApiUrl}/payments/v1/payment/${domain}/profile`;
/** @deprecated **/
exports.orderUrl = `${config_1.baseApiUrl}/orders/v1/orders`;
exports.expandProductType = 'expand=lineItems[*].productType.id';
exports.expandDiscountCode = 'expand=discountCodes[*].discountCode.id';
exports.expandCustomerGroup = 'expand=customerGroup';
exports.customerGroupUrl = `${config_1.baseApiUrl}/carts/v1/customer-groups`;
//# sourceMappingURL=commercetools.js.map